import script from "./CollapsiblePropertyPriceHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyPriceHistory.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyPriceHistory.vue?vue&type=style&index=0&id=1436c2b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1436c2b7"]])

export default __exports__